// extracted by mini-css-extract-plugin
export default {"container":"customer_container__5z5qN","col":"customer_col__+wv2M"};